import { dataProps } from './properties'

export const setTailoringCollectionList = (state, payload) => {
    state.list = payload
}    

export const setTailoringCollectionData = (state, payload) => {
    state.props = payload
} 

export const resetTailoringCollectionData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringCollection/mutations.js